"use strict";

define('rs/form/form.view',['vertebrae', 'rs/helper', 'evisions/evimenu/evimenu'], function (Vertebrae, helper, EVIMenu) {
  var FormContentView = Vertebrae.View.extend({
    templates: {
      'form.init': 'renderInitFragment',
      'form.section.row': 'renderSectionRowFragment',
      'form.attachment.row': 'renderAttachmentRowFragment',
      'form.action': 'renderFormAction',
      'form.sidebar.action': 'renderFormSidebarAction',
      'comments.popover': 'renderCommentsPopoverFragment'
    },
    events: {
      'click .form-sidebar-closer': 'handleSideBarToggle',
      'keydown .form-sidebar-closer': 'handleSideBarToggle',
      'click .form-sidebar-section:not(.active)': 'handleSectionClick',
      'keydown .form-sidebar-section:not(.active)': 'handleSectionKeydown',
      'click .form-sidebar-attachment': 'handleAttachmentClick',
      'click .form-action': 'handleToolbarActionClick',
      'keydown .form-action': 'handleToolBarActionKeydown',
      'click .rs-navigation-previous': 'handlePreviousContentClick',
      'keydown .rs-navigation-previous': 'handlePreviousContentKeydown',
      'click .form-sidebar-action-btn': 'handleFormSidebarActionClick',
      'keydown .form-sidebar-action-btn': 'handleFormSidebarActionKeydown',
      'click .form-sidebar-header.closeable': 'handleFormSidebarHeaderToggle'
    },
    setupPageOverflow: function setupPageOverflow() {
      $(document.body).css('overflow', 'hidden');
    },
    teardownPageOverflow: function teardownPageOverflow() {
      $(document.body).css('overflow', '');
    },
    activateSection: function activateSection(section) {
      var sidebarEl = section.getSidebarElement();
      sidebarEl.addClass('active');
    },
    deactivateSection: function deactivateSection(section) {
      var sidebarEl = section.getSidebarElement();
      sidebarEl.removeClass('active');
    },
    render: function render() {
      this.setupPageOverflow();
      this.$el.html(this.renderInitFragment(this.getDelegate().getTemplateProperties()));
      this.resize();
      this.$el.find('.form-section-container').scroll(this.handleFormScroll.proxy(this));
      this.setupScroll();
    },
    resize: function resize() {
      var formHeader = this.$('.form-header'),
        formWrapper = this.$('.form-wrapper'),
        height = this.$el.height();
      formWrapper.height(height - formHeader.outerHeight());
      this._sectionContainerHeight = null;
      var sections = this.getDelegate().getSections(),
        len = sections.length,
        i = 0;
      for (i = 0; i < len; ++i) {
        sections[i].getView().$el.css({
          'min-height': this.getSectionHeight() + 'px'
        });
      }
    },
    refreshToolbarActions: function refreshToolbarActions(actions) {
      var container = this.$('.form-actions');
      actions.push({
        action: 'showHidden',
        text: 'Actions',
        large: true,
        collapsed: true,
        'fa-icon': 'tasks'
      });
      container.html(this.renderFormAction(actions));
    },
    getSectionSidebarContainer: function getSectionSidebarContainer() {
      return this.$('.form-sidebar-scroller');
    },
    getFormContentsContainer: function getFormContentsContainer() {
      return this.$('.form-section-container');
      ;
    },
    renderSidebar: function renderSidebar(sections, attachments) {
      var sidebarContainer = this.getSectionSidebarContainer(),
        delegate = this.getDelegate(),
        contentContainer = this.getFormContentsContainer(),
        attachmentContainer = null,
        len = 0,
        i = 0,
        section = null,
        attachment = null,
        sidebarFragment = null,
        el = null,
        workflowService = delegate.getWorkflowService(),
        answerList = workflowService ? workflowService.getTaskAnswers() : [],
        currentTask = workflowService ? workflowService.getTask() : null,
        checkListType = delegate.isDocTypeCheckList(),
        that = this;
      len = sections ? sections.length : 0;
      if (currentTask && (currentTask.getTaskTypeTaskName() == 'EDIT_COMPLETE' || currentTask.getTaskTypeTaskName() == 'IRB_LEGACY_COMPLETE' || currentTask.getTaskTypeTaskName() == 'IRB_ADMIN_EDIT')) {
        answerList = _.filter(answerList, function (a) {
          return a.value == 'YES';
        });
      } else {
        answerList = [];
      }
      for (i = 0; i < len; ++i) {
        section = sections[i];
        sidebarFragment = this.renderSectionRowFragment({
          comments: section.getComments(),
          edit: delegate.isDesignerMode() && !checkListType,
          text: this.getSectionText(section)
        });
        el = sidebarFragment.children();
        helper.datum(el, section.getView());
        sidebarContainer.append(sidebarFragment);
        this.sectionWasRendered(section, el);
      }
      if (delegate.isDesignerMode()) {
        if (!checkListType) {
          sidebarContainer.append('<div role="button" tabindex="0" class="add-section-btn">Add Section <span class="add-icon sprite-circled-plus-white-small"></span></div>');
        }
      } else if (!delegate.isPreviewMode() && answerList.length > 0 && currentTask) {
        sidebarContainer.append('<div class="form-sidebar-header actions-header closeable"><span class="form-sidebar-header-icon"></span><div>Routing</div><div class="form-sidebar-header-subtext">' + currentTask.getTaskTypeTaskQuestion() + '</div></div>').append('<div class="form-sidebar-actions-container"></div>').find('.form-sidebar-actions-container').append(this.renderFormSidebarAction(answerList, true));
      }
      sidebarContainer.append('<div class="form-sidebar-header attachments-header closeable"><span class="form-sidebar-header-icon"></span>Attachments</div>');
      attachmentContainer = sidebarContainer.append('<div class="form-sidebar-attachments-container"></div>').find('.form-sidebar-attachments-container');
      len = attachments ? attachments.length : 0;
      for (i = 0; i < len; ++i) {
        attachment = attachments[i];
        attachment.viewer = !delegate.isDesignerMode();
        sidebarFragment = that.renderAttachmentRowFragment(attachment);
        el = sidebarFragment.children();
        helper.datum(el, attachment.getView());
        attachment.setup(el);
        attachmentContainer.append(sidebarFragment);
      }
      if (delegate.isDesignerMode()) {
        sidebarContainer.append('<div role="button" tabindex="0" class="add-attachment-btn">Add Attachment <span class="add-icon sprite-circled-plus-white-small"></span></div>');
      }
    },
    enableSidebarAction: function enableSidebarAction() {
      this.$('.actions-header').show();
      this.$('.form-sidebar-action-btn').removeClass('disabled').show();
    },
    disableSidebarAction: function disableSidebarAction() {
      this.$('.actions-header').hide();
      this.$('.form-sidebar-action-btn').addClass('disabled').hide();
    },
    renderNewSection: function renderNewSection(section) {
      var addBtn = this.$('.add-section-btn'),
        sectionText = {
          text: this.getSectionText(section),
          edit: this.getDelegate().isDesignerMode()
        },
        sidebarFragment = this.renderSectionRowFragment(sectionText),
        sidebarElement = sidebarFragment.children();
      helper.datum(sidebarElement, section.getView());
      addBtn.before(sidebarFragment);
      this.sectionWasRendered(section, sidebarElement);
    },
    renderNewAttachment: function renderNewAttachment(attachment) {
      var attachmentContainer = this.$('.form-sidebar-attachments-container'),
        attachmentFragment = this.renderAttachmentRowFragment(attachment),
        attachmentElement = attachmentFragment.children();
      attachmentContainer.append(attachmentFragment);
      this.updateScrollSidebar();
      return attachmentElement;
    },
    sectionWasRemoved: function sectionWasRemoved(section) {
      this.stopListening(section);
      this.updateScrollSidebar();
    },
    sectionWasRendered: function sectionWasRendered(section, sidebarElement) {
      var that = this,
        delegate = this.getDelegate();
      section.setSidebarElement(sidebarElement);
      if (delegate.isDesignerMode()) {
        this.listenTo(section, 'change:label', function () {
          that.sectionLabelDidChange(section, sidebarElement);
        });
        this.listenTo(section, 'change:text', function () {
          that.sectionLabelDidChange(section, sidebarElement);
        });
      } else {
        this.listenTo(section, 'change:displayed', function () {
          that.sectionDisplayDidChange(section, sidebarElement);
        });
        this.sectionDisplayDidChange(section, sidebarElement);
      }
      this.updateScrollSidebar();
    },
    hideAttachmentHeader: function hideAttachmentHeader() {
      this.$('.attachments-header').hide();
    },
    showAttachmentHeader: function showAttachmentHeader() {
      this.$('.attachments-header').show();
    },
    getSectionHeight: function getSectionHeight() {
      if (!this._sectionContainerHeight) {
        var container = this.$el.find('.form-section-container'),
          height = container.height() - 20;
        this._sectionContainerHeight = height;
      }
      return this._sectionContainerHeight;
    },
    getSectionWidth: function getSectionWidth(outer) {
      var el = this.$el.find('.form-section-container');
      return outer ? el.outerWidth(true) : el.width(outer);
    },
    createSectionElement: function createSectionElement() {
      var container = $("<div />");
      container.css({
        width: '100%',
        'min-height': this.getSectionHeight() + 'px',
        'display': 'none'
      });
      this.getFormContentsContainer().append(container);
      return container;
    },
    sectionDisplayDidChange: function sectionDisplayDidChange(section, el) {
      if (section.isVisible()) {
        el.show();
      } else {
        el.hide();
      }
    },
    sectionLabelDidChange: function sectionLabelDidChange(section, el) {
      el.find('.section-label').text(this.getSectionText(section));
    },
    formObjectWasDeleted: function formObjectWasDeleted(view) {},
    getSectionText: function getSectionText(section) {
      var label = section.getLabel();
      return (label ? label + ' ' : label) + section.getText();
    },
    handleSectionKeydown: function handleSectionKeydown(ev) {
      if (ev.keyCode === 13) {
        this.handleSectionClick(ev);
      }
    },
    handleSectionClick: function handleSectionClick(ev) {
      var section = helper.datum(ev.currentTarget);
      if (section) {
        this.getDelegate().requestSectionActivate(section.getDelegate());
      }
    },
    handleSideBarToggle: function handleSideBarToggle(ev) {
      var isCurrentlyClosed, $formWrapper, $sectionNav, $sectionItems;
      if (ev.keyCode && ev.keyCode !== 13) {
        return;
      }
      $formWrapper = this.$('.form-wrapper');
      isCurrentlyClosed = $formWrapper.hasClass('closed-sidebar');
      $sectionNavToggleBtn = $formWrapper.find('#sectionNavToggleBtn');
      $sectionItems = $formWrapper.find('#sectionItems');
      $sectionNavToggleBtn.attr({
        'aria-expanded': isCurrentlyClosed ? 'true' : 'false',
        'aria-label': isCurrentlyClosed ? 'close sections menu' : 'open sections menu'
      });
      if (isCurrentlyClosed) {
        $sectionItems.removeAttr('aria-hidden');
      } else {
        $sectionItems.attr('aria-hidden', 'true');
      }
      $formWrapper.toggleClass('closed-sidebar');
    },
    addShadowClass: function addShadowClass() {
      if (!this._hasShadowClass) {
        this.$('.form-header').addClass('shadow');
        this._hasShadowClass = true;
      }
    },
    removeShadowClass: function removeShadowClass() {
      if (this._hasShadowClass) {
        this.$('.form-header').removeClass('shadow');
        this._hasShadowClass = false;
      }
    },
    showFormActionsDropdown: function showFormActionsDropdown(actions) {
      var options = _.chain(actions).filter(function (m) {
        return !m.noHide;
      }).value();
      return EVIMenu.show({
        className: 'rs-menu',
        element: $(".form-action[data-action='showHidden']"),
        offset: {
          top: 17,
          left: 24
        }
      }, options).bind(this).then(function (ndx) {
        if (!options[ndx.index].disabled) {
          this.executeFormAction(options[ndx.index].action, options[ndx.index].value);
        }
      });
    },
    handleFormScroll: function handleFormScroll(ev) {
      if (ev.currentTarget.scrollTop > 0) {
        this.addShadowClass();
      } else {
        this.removeShadowClass();
      }
    },
    handleAttachmentClick: function handleAttachmentClick(ev) {
      var attachment = helper.datum(ev.currentTarget);
      if (attachment) {
        this.getDelegate().requestAttachmentAction(attachment.getDelegate());
      }
    },
    handleToolBarActionKeydown: function handleToolBarActionKeydown(ev) {
      if (ev.which === 13) {
        this.handleToolbarActionClick(ev);
      }
    },
    handleToolbarActionClick: function handleToolbarActionClick(ev) {
      var $el = $(ev.currentTarget),
        action = $el.data('action'),
        value = $el.data('value');
      if (!$el.hasClass('disabled')) {
        this.executeFormAction(action, value);
      }
    },
    executeFormAction: function executeFormAction(action, value) {
      var fnName = 'request' + helper.camelCase(action + '') + 'Action',
        delegate = this.getDelegate();
      if (action && delegate[fnName]) {
        delegate[fnName](value);
      }
    },
    handleFormSidebarActionClick: function handleFormSidebarActionClick(ev) {
      var el = $(ev.currentTarget),
        data = helper.datum(el) || {};
      this.getDelegate().requestWorkflowAction(data.value);
    },
    handleFormSidebarActionKeydown: function handleFormSidebarActionKeydown(ev) {
      if (ev.which === 13) {
        this.handleFormSidebarActionClick(ev);
      }
    },
    setupScroll: function setupScroll() {},
    updateSectionScroll: function updateSectionScroll() {},
    updateScrollSidebar: function updateScrollSidebar() {},
    scrollToFormObject: function scrollToFormObject(formObject) {
      var formObjectView = formObject.getView(),
        delegate = this.getDelegate(),
        section = delegate.getActiveSection(),
        sectionOffset = section.getView().$el.offset(),
        elOffset = formObjectView.$el.offset(),
        scrollTop = elOffset.top - sectionOffset.top;
      if (formObject.section !== true) {
        scrollTop -= 20;
      }
      return section.getView().setScrollTop(scrollTop, {
        silent: true
      });
    },
    handlePreviousContentKeydown: function handlePreviousContentKeydown(ev) {
      if (ev.which === 13) {
        this.handlePreviousContentClick(ev);
      }
    },
    handlePreviousContentClick: function handlePreviousContentClick() {
      this.getDelegate().requestPreviousContentController();
    },
    handleFormSidebarHeaderToggle: function handleFormSidebarHeaderToggle(ev) {
      var el = $(ev.currentTarget);
      el.next().toggle();
      el.toggleClass('closed');
    },
    unload: function unload() {
      this.teardownPageOverflow();
      this._super.apply(this, arguments);
    },
    getCommentText: function getCommentText(comment) {
      var div = document.createElement('DIV');
      div.innerHTML = comment.text;
      return div.innerText || div.textContent;
    }
  });
  return FormContentView;
});

